import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-statement',
  templateUrl: './cookie-statement.component.html',
  styleUrls: ['./cookie-statement.component.scss']
})
export class CookieStatementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
